import { render, staticRenderFns } from "./UserBar.vue?vue&type=template&id=7b019de6&scoped=true"
import script from "./UserBar.vue?vue&type=script&lang=js"
export * from "./UserBar.vue?vue&type=script&lang=js"
import style0 from "./UserBar.vue?vue&type=style&index=0&id=7b019de6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b019de6",
  null
  
)

export default component.exports